module.exports = __webpack_public_path__ + "img/Industrial Building - Five star MIDC.ad71f391.jpg";